var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 128,
    viewBox: "0 0 130 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.131 119.281H29.1292V126.977H101.131V119.281Z",
    fill: "#8FBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3733 27.144H41.9884V73.4235H88.3733V27.144Z",
    fill: "#8DBEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4654 65.7279H51.6886C50.529 65.7279 49.5802 64.7791 49.5802 63.6195V36.8428C49.5802 35.6832 50.529 34.7344 51.6886 34.7344H78.4654C79.625 34.7344 80.5738 35.6832 80.5738 36.8428V63.6195C80.5738 64.7791 79.625 65.7279 78.4654 65.7279Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.433 45.9092H105.24V81.8575H128.433V45.9092Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.433 22.822H105.24V46.0145H128.433V22.822Z",
    fill: "#4796FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.911 24.614H9.51965V83.7548H24.911V24.614Z",
    fill: "#4796FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82434 8.69556H128.329",
    stroke: "#8DBEFF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1036 119.282V108.107",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0509 108.107V119.282",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1734 1H1.82434V108.107H102.29",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1349 1H128.329V108.107H111.251",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.329 97.8811H1.82434",
    stroke: "#8DBEFF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9422 126.977H101.131V119.281H29.1292V126.977H36.0869",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6176 83.7548H54.5335",
    stroke: "#8DBEFF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6604 60.8787V39.7946",
    stroke: "#8DBEFF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.327 45.9092H105.24",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M120.633 30.5176H112.938",
    stroke: "#DFEDFE",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.633 38.2134H112.938",
    stroke: "#DFEDFE",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.911 24.614H9.51965V83.7548H24.911V24.614Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2679 27.144H41.9884V73.4235H88.2679V27.144Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9791 34.84V43.1682C68.9791 44.0115 68.0303 44.4332 67.3978 44.0115L65.711 42.8519C65.3948 42.6411 64.8677 42.6411 64.5514 42.8519L62.8648 44.0115C62.2322 44.4332 61.2834 44.0115 61.2834 43.1682V34.84",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4654 65.7279H51.6886C50.529 65.7279 49.5802 64.7791 49.5802 63.6195V36.8428C49.5802 35.6832 50.529 34.7344 51.6886 34.7344H78.4654C79.625 34.7344 80.5738 35.6832 80.5738 36.8428V63.6195C80.5738 64.7791 79.625 65.7279 78.4654 65.7279Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8277 59.0865H68.6621",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2716 27.1441L90.8017 24.614",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9872 27.1441L39.3517 24.614",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2716 73.4236L90.8017 76.0591",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9872 73.4236L39.3517 76.0591",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M128.327 81.9628H105.24V22.822H128.327",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M120.633 53.6047H112.938V74.1617H120.633V53.6047Z",
    fill: "url(#paint0_linear_6619_1797)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M120.633 53.6047H112.938V74.1617H120.633V53.6047Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6619_1797",
    x1: 113.293,
    y1: 54.615,
    x2: 120.813,
    y2: 74.7274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DBEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialDevelopment);
export default __webpack_public_path__ + "static/media/material-development.50e08a9334bfd52068c4b8981769a531.svg";
export { ForwardRef as ReactComponent };